const Error = ({
  width = '24',
  height = '24',
  className = '',
  title = '',
  stroke = '1.5',
  role = '',
  filled = false
}): React.ReactNode => {
  const hidden = title && title.length > 0 ? false : true;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="#000000"
      className={className}
      aria-hidden={`${hidden}`}
      role={role ? role : hidden ? 'graphics-document' : 'img'}
    >
      {!hidden && <title>{title}</title>}
      <path
        d="M12 22C14.6522 22 17.1957 20.9464 19.0711 19.0711C20.9464 17.1957 22 14.6522 22 12C22 9.34784 20.9464 6.8043 19.0711 4.92893C17.1957 3.05357 14.6522 2 12 2C9.34784 2 6.8043 3.05357 4.92893 4.92893C3.05357 6.8043 2 9.34784 2 12C2 14.6522 3.05357 17.1957 4.92893 19.0711C6.8043 20.9464 9.34784 22 12 22Z"
        stroke={filled ? 'transparent' : 'currentColor'}
        fill={filled ? '#A90508' : 'none'}
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.3344 8.66663L8.66666 15.3333"
        stroke={filled ? 'white' : 'currentColor'}
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.66666 8.66663L15.3344 15.3333"
        stroke={filled ? 'white' : 'currentColor'}
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Error;
